import React, { Component } from 'react';
import Button from "@material-ui/core/Button";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid } from '@material-ui/core'
import Swal from "sweetalert2";
import PeopleIcon from '@material-ui/icons/People';
import Chip from '@material-ui/core/Chip';
import './Card.css';
import { withRouter } from 'react-router-dom';

class Card2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fill: this.props.uid? true:false,
        }
    }

    componentDidMount() {
    }

    handleStart = () => {

        if (this.props.uid === null)
            Swal.fire({
                title: "Please Login First!!",
                icon: "error"
            });
        else
            this.props.history.push('/quiz/java-stack-quiz');
    }

    render() {
        return (
            <Grid container className="card-div">
                <Card className="single-card fix-width">
                    <Grid item xs={12} md={5} style={{ alignSelf: 'center' }}>
                        <img
                            width="100%"
                            src="/images/java.jpeg"
                            title="Recruiting Monk"
                            className="skeleton"
                        />
                    </Grid>
                    <Grid item xs={12} md={7} className="detail">
                        <CardContent className="title">
                            <h3>Java Stack - I</h3>
                            <div className="float"><h5>Duration: 10 mins</h5></div>
                        </CardContent>
                        <CardContent style={{ paddingBottom: '20px' }}>
                            <div className="chip-container">
                                <Chip className="chip" variant="outlined" label="Fundamentals" color="secondary" />
                                <Chip className="chip" variant="outlined" label="Java" color="secondary" />
                            </div>
                            <div className="float">
                                {
                                   this.props.uid && this.props.details && this.props.details.attempted ? <span className="score">{this.props.details.reviewed ? ` Score: ${this.props.details.score}/10`:`Result awaited`}</span> : 
                                   <Button className="take-quiz" variant="outlined" size="small" onClick={this.handleStart} >Take Quiz</Button>                                      
                                }
                            </div>
                            <span className="taken"><span className="count">{this.props.recruiters} </span> Recruiters <PeopleIcon fontSize="small" className="count-icon" style={{ paddingLeft: '5px' }} /></span>
                        </CardContent>
                    </Grid>
                </Card>
            </Grid>
        );
    }
}

export default withRouter(Card2);